/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMinRightIcon64Regular = forwardRef('ArrowDim2DiagMinRightIcon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M57.56 8.56a1.5 1.5 0 0 0-2.12-2.12L37 24.878V9.5a1.5 1.5 0 0 0-3 0V25a5 5 0 0 0 5 5h15.5a1.5 1.5 0 0 0 0-3H39.121l18.44-18.44Z" }),
        React.createElement("path", { d: "M27 39.121 8.56 57.561a1.5 1.5 0 0 1-2.12-2.122L24.878 37H9.5a1.5 1.5 0 0 1 0-3H25a5 5 0 0 1 5 5v15.5a1.5 1.5 0 0 1-3 0V39.121Z" })));
});
